import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TabState {
  postTab: string;
  rankTab: string;
  companyTab: string;
  blogTab: string;
}

const initialState: TabState = {
  postTab: "실시간",
  rankTab: "스코어",
  companyTab: "증권사",
  blogTab: "최신",
};

const tabSlice = createSlice({
  name: "tab",
  initialState,
  reducers: {
    setPostTab: (state, action: PayloadAction<string>) => {
      state.postTab = action.payload;
    },
    setRankTab: (state, action: PayloadAction<string>) => {
      state.rankTab = action.payload;
    },
    setCompanyTab: (state, action: PayloadAction<string>) => {
      state.companyTab = action.payload;
    },
    setBlogTab: (state, action: PayloadAction<string>) => {
      state.blogTab = action.payload;
    },
  },
});

export const { setPostTab, setRankTab, setCompanyTab, setBlogTab } = tabSlice.actions;
export default tabSlice.reducer;
